import React from 'react';
import { motion } from 'framer-motion';
import { LockIcon, DownloadIcon, RefreshCwIcon } from 'lucide-react';
import { handleCheckoutClick, CHECKOUT_URL } from '../lib/pixel';
export function FinalCTA() {
  return <section className="py-20 lg:py-32 bg-[#1A3320]" data-id="element-30">
      <div className="container mx-auto px-6 lg:px-12" data-id="element-31">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-4xl mx-auto text-center" data-id="element-32">
          <div className="inline-flex items-center gap-2 bg-[#C9A84C] text-black px-4 py-2 rounded-full text-xs font-bold uppercase mb-6" data-id="element-33">
            OFERTA DE LANZAMIENTO
          </div>

          <h2 className="text-4xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-34">
            Recupera el control de tu cuerpo hoy mismo
          </h2>

          <p className="text-xl text-white italic mb-8" data-id="element-35">
            No permitas que otro mes de frustración pase mientras tu metabolismo
            sigue bloqueado.
          </p>

          <p className="text-white mb-6" data-id="element-36">
            📖 eBook Completo ($37) + 📋 Protocolo 21 Días ($27) + ✅ Checklists
            ($17)
          </p>

          <p className="text-2xl text-[#C9A84C] font-bold mb-4" data-id="element-37">
            Todo por solo $8.49 USD hoy
          </p>

          <div className="flex items-baseline justify-center gap-4 mb-4" data-id="element-38">
            <span className="text-gray-400 line-through text-xl" data-id="element-39">$81.00</span>
            <span className="text-[#C9A84C] text-6xl font-bold" data-id="element-40">$8.49</span>
            <span className="text-white text-xl" data-id="element-41">USD</span>
          </div>

          <p className="text-[#C2856A] text-sm font-semibold mb-8" data-id="element-42">
            ⏰ Precio de lanzamiento · Sube a $27 pronto
          </p>

          <a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" onClick={handleCheckoutClick} className="block text-center w-full lg:w-auto lg:inline-block bg-[#C9A84C] text-black px-12 py-6 rounded-full text-xl font-bold uppercase hover:brightness-110 transition-all shadow-2xl mb-8" data-id="element-43">
            SÍ, QUIERO MI PROTOCOLO HORMONAL AHORA →
          </a>

          <div className="flex flex-wrap justify-center gap-8 mb-8" data-id="element-44">
            <div className="flex items-center gap-2 text-white text-sm" data-id="element-45">
              <LockIcon className="w-5 h-5" data-id="element-46" />
              <span data-id="element-47">Pago Seguro Shopify</span>
            </div>
            <div className="flex items-center gap-2 text-white text-sm" data-id="element-48">
              <DownloadIcon className="w-5 h-5" data-id="element-49" />
              <span data-id="element-50">Descarga Inmediata</span>
            </div>
            <div className="flex items-center gap-2 text-white text-sm" data-id="element-51">
              <RefreshCwIcon className="w-5 h-5" data-id="element-52" />
              <span data-id="element-53">Garantía 30 Días</span>
            </div>
          </div>

          <p className="text-xs text-gray-500" data-id="element-54">
            © 2025 Código Hormonal 40+ · codigohormonal40.com · Los resultados
            pueden variar. Este producto tiene fines informativos y no sustituye
            el consejo médico profesional.
          </p>
        </motion.div>
      </div>
    </section>;
}